import React, { Component } from 'react';
import "./LogoHeader.css";

import 'moment/locale/zh-cn';

export default class LogoHeader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // formatMessage: this.props.intl['formatMessage'],

        }
    }

    render() {
        const img = require("../../../../../../images/logo_white.svg")
        return (
            <div className="header-container">
                <div className="header-logo">
                    <img src={img} />
                </div>
                <div className="header-slogan">
                    <div className="header-slogan-main">
                        i选址
                    </div>
                    <div className="header-slogan-info">
                        仓库选址更靠谱
                    </div>
                </div>
            </div>

        );
    }


}

